import deviceNavigationMenuTypes from '../../../consts/home/deviceNavigationMenuTypes';
import articleTypes from '../../../consts/loyalty/articleTypes';
import milestoneTypes from '../../../consts/loyalty/milestoneTypes';
import quizTypes from '../../../consts/loyalty/quizTypes';
import storiesTypes from '../../../consts/loyalty/storiesTypes';
import routes from '../../../consts/routes';
import {strCode} from '../../../consts/strCode';
import loyaltyService from '../../../services/loyalty/loyaltyService';
import {
    showClubPageArticleModal,
    showClubPagePuzzleModal,
    showClubPageQuizModal,
    showClubPageStories,
} from '../../../state/slice/modal';
import {setActiveDeviceNavigationMenuType, setIsHomeMenuExpanded} from '../../../state/slice/session';
import {dispatch} from '../../../state/store';
import uaUtils from '../../../utils/uaUtils';

const MILESTONE_CONFIG = {
    [milestoneTypes.ADD_APP_TO_HOME_SCREEN]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_WELCOME_ACTION_1_TITLE,
        descriptionStrCode: uaUtils.getIsAndroid()
            ? strCode.CLUB_PAGE_BADGE_WELCOME_ACTION_1_ANDROID_DESCRIPTION
            : strCode.CLUB_PAGE_BADGE_WELCOME_ACTION_1_DESCRIPTION,
        routeTo: routes.APP_INSTALLATION_GUIDE,
    },
    [milestoneTypes.IQOS_CLUB_VIDEO]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_IQOS_CLUB_VIDEO_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_IQOS_CLUB_VIDEO_DESCRIPTION,
        onClick: () => dispatch(showClubPageStories({storiesType: storiesTypes.HIGHLIGHTS})),
    },
    [milestoneTypes.IQOS_EXPERT_VIDEO]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_IQOS_EXPERT_VIDEO_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_IQOS_EXPERT_VIDEO_DESCRIPTION,
        onClick: () => dispatch(showClubPageArticleModal({articleType: articleTypes.ILUMA_I2})),
    },
    [milestoneTypes.CONNECT_DEVICE]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_CONNECTIVITY_ACTION_1_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_CONNECTIVITY_ACTION_1_DESCRIPTION,
        routeTo: routes.HOME,
    },
    [milestoneTypes.CHANGE_DEVICE_COLOR]: {
        titleStrCode: strCode.CLUB_PAGE_CHANGE_DEVICE_COLOR_MILESTONE_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_CHANGE_DEVICE_COLOR_MILESTONE_DESCRIPTION,
        routeTo: routes.APPEARANCE,
    },
    [milestoneTypes.EXPLORE_USAGE_INSIGHT]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_CONNECTIVITY_ACTION_3_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_CONNECTIVITY_ACTION_3_DESCRIPTION,
        onClick: () => {
            dispatch(setIsHomeMenuExpanded(true));
            dispatch(setActiveDeviceNavigationMenuType(deviceNavigationMenuTypes.INSIGHT));
        },
        routeTo: routes.HOME,
    },
    [milestoneTypes.READ_ARTICLE_1]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_ACTION_1_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_ACTION_1_DESCRIPTION,
        onClick: () => dispatch(showClubPageArticleModal({articleType: articleTypes.LEVIA})),
    },
    [milestoneTypes.READ_ARTICLE_2]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_ACTION_1_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_ACTION_1_DESCRIPTION,
        onClick: () => dispatch(showClubPageArticleModal({articleType: articleTypes.ILUMA_I2})),
    },
    [milestoneTypes.IQOS_EXPERT_QUIZ]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_ACTION_3_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_ACTION_3_DESCRIPTION,
        onClick: () => dispatch(showClubPageQuizModal({quizType: quizTypes.IQOS_EXPERT_QUIZ})),
    },
    [milestoneTypes.QUEST_CHAMPION_QUIZ]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_QUEST_CHAMPION_ACTION_2_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_QUEST_CHAMPION_ACTION_2_DESCRIPTION,
        onClick: () => dispatch(showClubPageStories({storiesType: storiesTypes.HIGHLIGHTS_AND_QUIZ})),
    },
    [milestoneTypes.DO_PUZZLE]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_QUEST_CHAMPION_ACTION_1_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_QUEST_CHAMPION_ACTION_1_DESCRIPTION,
        onClick: () => dispatch(showClubPagePuzzleModal()),
    },
    [milestoneTypes.SWITCH_11]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_11_DESCRIPTION,
        onClick: () =>
            loyaltyService.openSwitchMilestoneContent({
                storiesType: storiesTypes.HOW_TO_USE_STORIES,
                quizType: quizTypes.HOW_TO_USE_QUIZ,
            }),
    },
    [milestoneTypes.SWITCH_12]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_12_DESCRIPTION,
        onClick: () => dispatch(showClubPageStories({storiesType: storiesTypes.MANAGE_EXPECTATIONS})),
    },
    [milestoneTypes.SWITCH_13]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_13_DESCRIPTION,
        onClick: () => {
            loyaltyService.openSwitchMilestoneContent({
                storiesType: storiesTypes.TASTE_DISCOVERY,
                quizType: quizTypes.TASTE_DISCOVERY_QUIZ,
            });
        },
    },
    [milestoneTypes.SWITCH_14]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_14_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.EXCLUSIVE_USAGE}),
    },
    [milestoneTypes.SWITCH_15]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_15_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.SUPERIORITY_CONVENIENCE}),
    },
    [milestoneTypes.SWITCH_21]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_21_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.FIND_PLEASURE}),
    },
    [milestoneTypes.SWITCH_22]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_22_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.COMMUNITY}),
    },
    [milestoneTypes.SWITCH_23]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_23_DESCRIPTION,
        onClick: () =>
            loyaltyService.openSwitchMilestoneContent({
                storiesType: storiesTypes.MOTIVATION,
                quizType: quizTypes.MOTIVATION_QUIZ,
            }),
    },
    [milestoneTypes.SWITCH_24]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_24_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.TIPS_AND_TRICKS}),
    },
    [milestoneTypes.SWITCH_25]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_25_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.SATISFACTION}),
    },
    [milestoneTypes.SWITCH_31]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_31_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_31_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.MOST_POPULAR_FLAVOURS}),
    },
    [milestoneTypes.SWITCH_32]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_32_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.ADVANCED_FEATURES}),
    },
    [milestoneTypes.SWITCH_33]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_33_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({storiesType: storiesTypes.SERVICES_AND_PRIVILEGES}),
    },
    [milestoneTypes.SWITCH_34]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_34_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_34_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({quizType: quizTypes.QUIZ_CIRQULAR_PROGRAMME}),
    },
    [milestoneTypes.SWITCH_35]: {
        titleStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_35_TITLE,
        descriptionStrCode: strCode.CLUB_PAGE_MILESTONE_SWITCH_35_DESCRIPTION,
        onClick: () => loyaltyService.openSwitchMilestoneContent({quizType: quizTypes.GRAND_FINALE_QUIZ}),
    },
};

export default MILESTONE_CONFIG;
